import React, {useEffect, useState} from 'react';
import {fetchGsmResultDetails, fetchSpectrumViewerData, setGsmResults, setSelectedSpectrum} from "../actions/GsmResultsAction";
import {useSelector, useDispatch} from "react-redux";

const rootStyle = {};

const margin = 3;
const clusterHeight = 14;
const strokeWidth = 2;

function getMousePosition(evt) {
    const CTM = evt.target.getScreenCTM();
    return {
        x: (evt.clientX - CTM.e) / CTM.a,
        y: (evt.clientY - CTM.f) / CTM.d
    };
}

export default function ElutionCurve() {

    const elutionCurve = useSelector(state => state.massGroupReducer.elutionCurve);
    const dispatch = useDispatch();
    const [selected, setSelected] = useState();
    const [mouseOver, setMouseOver] = useState(-1);
    useEffect(() => {
        setSelected(undefined);
        setMouseOver(-1);
    }, [elutionCurve]);

    const handleClick = (item) => {
        const gsmKey = item.gsmKey;
        dispatch(fetchGsmResultDetails(gsmKey));
        dispatch(fetchSpectrumViewerData(gsmKey));
        setSelected(item);
    };

    const structureElutionList = elutionCurve ? elutionCurve.structureElutionList : [];
    const minRT = structureElutionList.length === 0 ? 0 : Math.min.apply(Math, structureElutionList.map((item) => item.rtMin + item.rtWidth)) - 30;
    const maxRT = structureElutionList.length === 0 ? 0 : Math.max.apply(Math, structureElutionList.map((item) => item.rtMin + item.rtWidth)) + 30;

    const scale = 2;
    const width = (maxRT - minRT) * scale;
    return (
        <div className="flex-grow-1" style={rootStyle}>
            <svg width={width} height={300} color={'grey'}
                 onClick={(e) => {
                     e.preventDefault();
                     e.stopPropagation();
                     setSelected(undefined);
                     dispatch(setGsmResults(undefined));
                     dispatch(setSelectedSpectrum({
                         peaks: []
                     }))
                 }}
                 onMouseMove={(e) => {
                     let index = Math.floor(getMousePosition(e).y / (clusterHeight + margin));
                     if(index + 1 > elutionCurve.runCount)
                         index = -1;
                     if(index !== mouseOver)
                         setMouseOver(index);
                 }}
                 onMouseLeave={(e) => setMouseOver(-1)}
            >
                mouseOver > -1 && <rect x ={0} y={mouseOver * (clusterHeight + margin)} width={width} height={clusterHeight + margin + 1} fill={'#fbfbfb'}/>
                {
                    Array.from({length: elutionCurve.runCount + 1}, (v, k) => k + 1).map((item, index) => {
                        const y = margin + index * clusterHeight + index * margin - margin / 2;
                        return <line key={'line_' + index} x1={0} y1={y} x2={width} y2={y} stroke={'#eeeeee'} shapeRendering="crispEdges"/>
                    })
                }
                {
                    structureElutionList.map((item, index) => {
                        const strokeOpacity = selected ? item === selected ? 1 : 0.3 : 1;
                        const scoreOpacity = Math.min(item.openMetaScore * 2.5 - 0.75, 1);
                        return <rect key={index}
                                     x={(item.rtMin - minRT) * scale}
                                     y={(margin + item.runIndex * clusterHeight + item.runIndex * margin) + 1}
                                     width={Math.max((item.rtWidth * scale) - strokeWidth, 1)}
                                     height={clusterHeight - strokeWidth}
                                     fill={item.fill} fillOpacity={scoreOpacity * strokeOpacity}
                                     stroke={item.fill} strokeOpacity={strokeOpacity}
                                     strokeWidth={strokeWidth}
                                     onClick={(e) => {
                                         e.preventDefault();
                                         e.stopPropagation();
                                         handleClick(item);
                                     }}
                                     shapeRendering="crispEdges"
                        />;
                    })
                }
            </svg>
        </div>
    );
}